import { render, staticRenderFns } from "./CandidatesRemoveExamRequest.vue?vue&type=template&id=03dc97d2&lang=pug"
import script from "./CandidatesRemoveExamRequest.vue?vue&type=script&lang=js"
export * from "./CandidatesRemoveExamRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports